import { createAPI } from '@common'
export default {
  // 特殊登录获取服务器时间戳对时接口
  getSystemTime: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0ujnf', 'GET', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),
  // 设置本地公私钥
  setLocalPubKey: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0vtfs0qvcLfz', 'POST', config, {
      neverLoading: true,
      isHideErrorMessage: true
    }),
  // 设置本地公私钥
  setLocalPubKeyByLogin: (config) =>
    createAPI('customEncryptApiName-1/0nfejby.tztufn0mphjo0vtfs0qvcLfz', 'POST', config, {
      neverLoading: true,
      isHideErrorMessage: true
    })
}
